export default "__VITE_ASSET__Bl7CGTs4__"